<div *ngIf="sessionService.isInternUser">
  <div class="accordion-container">
    <p-accordion #accordion>
     <!-- <p-accordionTab *ngFor="let item of row.accordionItems; let index = index"> -->
        <p-accordion-panel *ngFor="let item of row.accordionItems; let index = index" [value]="index">
        <ng-template pTemplate="icon" let-collapsed>
          <i class="pi" [ngClass]="!collapsed ? 'pi-chevron-down' : 'pi-chevron-up'" style="margin-right: 5px"></i>
        </ng-template>
<!--        <ng-template pTemplate="header">-->
          <p-accordion-header>
          <div class="d-flex justify-content-between w-100">
            <div class="intern-grid w-100">
              @if (!expanded(index)) {
                <span>{{ item.itemName }}</span>
                <span class="total-number">
                  <span class="mas-badge warning">
                    {{ item.warnings.length }}
                  </span>
                </span>
                <span class="new-number">
                  <span class="mas-badge">
                    {{ item.newWarnings }}
                  </span>
                </span>
              } @else {
                <span class=""
                  ><span (click)="$event.stopPropagation(); goToLarmKriterium(item.itemName)">
                    {{ item.itemName }}
                  </span></span
                >
                <span></span>
                <span></span>
                <span
                  class="go-to-kriteria link-like float-right"
                  (click)="$event.stopPropagation(); goToLarmKriterium(item.itemName)"
                >
                  <p><i class="fa-solid fa-up-right-from-square"></i> Till larmkriteria</p>
                </span>
              }
            </div>
          </div>
          </p-accordion-header>
          <p-accordion-content>
          <ng-container *ngFor="let result of item.warnings">
            <div class="">
              @if (result.newWarning) {
                <div class="warning-item new-warning d-flex justify-content-between">
                  <div>
                    <i class="fas fa-triangle-exclamation me-2 text-danger text-large"></i>
                    @if (authorizationService.isInternSuperUser()) {

                      <span class="link-like" (click)="goToProv(result.provLabbProvtagningsar)">{{ result.provId }}</span> - Ny varning
                    } @else {
                      <span>{{ result.provId }}</span> - Ny varning
                    }
                  </div>
                  <div *ngIf="authorizationService.isInternSuperUser()" class="link-like" (click)="goToProv(result.provLabbProvtagningsar)">
                    <i class="fa-solid fa-up-right-from-square"></i> Gå till prov ID
                  </div>
                </div>
              } @else {
                <div class="warning-item recurring-warning d-flex justify-content-between">
                  <div>
                    <i class="fas fa-triangle-exclamation me-2 text-warning text-large"></i>
                    @if (authorizationService.isInternSuperUser()) {

                      <span class="link-like" (click)="goToProv(result.provLabbProvtagningsar)">{{ result.provId }}</span> - Återkommande varning
                    } @else {
                      <span>{{ result.provId }}</span> - Återkommande varning
                    }

                  </div>
                  <div *ngIf="authorizationService.isInternSuperUser()" class="link-like" (click)="goToProv(result.provLabbProvtagningsar)">
                    <i class="fa-solid fa-up-right-from-square"></i> Gå till prov ID
                  </div>
                </div>
              }

              <div></div>
              <div class="link-like" (click)="goToProv(result.provLabbProvtagningsar)"></div>
            </div>
          </ng-container>
     <!--  </p-accordionTab> -->
          </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
  </div>
</div>

<div *ngIf="!sessionService.isInternUser" class="extern-info">
  <ng-container *ngFor="let warning of row.warnings">
    <div>
      @if (warning.newWarning) {
        <div class="warning-item new-warning d-flex justify-content-between">
          <div>
            <i class="fas fa-triangle-exclamation me-2 text-danger text-large"></i>
            <span>{{ warning.provId }}</span> - Ny varning
          </div>
        </div>
      } @else {
        <div class="warning-item recurring-warning d-flex justify-content-between">
          <div>
            <i class="fas fa-triangle-exclamation me-2 text-warning text-large"></i>
            <span>{{ warning.provId }}</span> - Återkommande varning
          </div>
        </div>
      }
    </div>
  </ng-container>
  <div class="go-to-kriteria link-like" (click)="goToLarmKriterium(row.itemName)">
    <p><i class="fa-solid fa-up-right-from-square"></i> Till larmkriteria</p>
  </div>
</div>
